const doc = [({"da":({"js":({"admin":({"employee_prices":({"create_card":({"the_employee_price_was_saved":"Medarbejderens priser blev gemt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;